import { render, staticRenderFns } from "./Popup01Description.vue?vue&type=template&id=0bc36cb4&scoped=true"
import script from "./Popup01Description.vue?vue&type=script&lang=js"
export * from "./Popup01Description.vue?vue&type=script&lang=js"
import style0 from "./Popup01Description.vue?vue&type=style&index=0&id=0bc36cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc36cb4",
  null
  
)

export default component.exports